import React, { useEffect, useState } from "react";
import moment from 'moment';

import {
  CircularProgress,
  Grid,
  Select,
  MenuItem,
  TextField,
  Modal,
  IconButton ,
  Tooltip ,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetMaterialReplacement, getSalesOffices,GetMaterialList } from "../../utils/GetAdmin";
import { saveMaterialReplacementDL } from "../../utils/PostAdmin";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import TableAbstraction  from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { GetAllMaterialText, materialText } from "../../utils/GetAML"

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: 500,
      maxWidth: 500
    },
    modalInput: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

export default function AdminMaterialReplacement() {
  const classes = useStyles();
  const [materialReplacement, SetMaterialReplacement] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  
  const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);
  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowObsoletematerial, seteditedRowObsoletematerial] = React.useState<string>("");
  const [editedRowReplacementmaterial, seteditedRowReplacementmaterial] = React.useState<string>("");
  const [editedRowValidfrom, seteditedRowValidfrom] = React.useState<string>("");
  const [editedRowValidto, seteditedRowValidto] = React.useState<string>("");
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
  const [materialTexts,setMaterialTexts] = useState<materialText[]>([]);
  const [materialList,setMaterialList] = useState<materialText[]>([]);
  const handleModalClose = () => {
    setEditedRowDeliveringPlant('');
    seteditedRowObsoletematerial('');
    seteditedRowReplacementmaterial('');
    seteditedRowValidfrom('');
    seteditedRowValidto('');
    setOpenEditWindow(false);
  }

 


  const handleDelete = () => {
    let oldreplacement = (editedRow) ? {
      salesOffice: editedRow.plant,
      deliveringPlant: editedRow.plant,
      obsoleteMaterialNum:editedRow.obsoleteMaterialNum,
      replacementMaterialNum:editedRow.replacementMaterialNum,
      validFromDt:editedRow.validFromDt,
      validToDt:editedRow.validToDt,
    } : undefined;
    saveMaterialReplacementDL(salesOrg,oldreplacement,undefined).then(ret => {
      if(ret && ret.data){
        SetMaterialReplacement(ret.data.mdMaterialReplacement)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    }); 
    setEditedRow(undefined);
  }
  const handleModalSave = () => {
    let oldreplacement = (editedRow) ? {
      salesOffice: editedRow.plant,
      deliveringPlant: editedRow.plant,
      obsoleteMaterialNum:editedRow.obsoleteMaterialNum,
      replacementMaterialNum:editedRow.replacementMaterialNum,
      validFromDt:editedRow.validFromDt,
      validToDt:editedRow.validToDt,
    } : undefined;
    let newreplacement = {salesOffice:editedRowDeliveringPlant,deliveringPlant:editedRowDeliveringPlant,obsoleteMaterialNum:editedRowObsoletematerial, replacementMaterialNum:editedRowReplacementmaterial,validFromDt:editedRowValidfrom,validToDt:editedRowValidto};
    saveMaterialReplacementDL(salesOrg,oldreplacement,newreplacement).then(ret => {
     
      if(ret && ret.data){
        SetMaterialReplacement(ret.data.mdMaterialReplacement)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });


    setOpenEditWindow(false);
    setEditedRow(undefined);
  } 
  const handleEdit = (tableRow:any) => {
    setCurrent(tableRow);
    setOpenEditWindow(true);
  }
  const setCurrent = (tableRow:any) => {
    setEditedRow(tableRow);
    setEditedRowDeliveringPlant(tableRow.plant);
    seteditedRowObsoletematerial(tableRow.obsoleteMaterialNum);
    seteditedRowReplacementmaterial(tableRow.replacementMaterialNum);
    seteditedRowValidfrom(tableRow.validFromDt);
    seteditedRowValidto(tableRow.validToDt);
  }
  const getMaterialNum = (deliveringPlants:any) => {
    seteditedRowReplacementmaterial('');
    GetMaterialList(salesOrg,deliveringPlants).then((v) => {
       if(v) setMaterialList(v);
     })
  
 }
  const getMaterialText = (materialNum:string) =>{
    let materialNumShort: string = "";
    let description: string = "";
    if(materialTexts && materialTexts.length > 0){
      let mt = materialTexts.find( (mt) => mt.materialNum === materialNum);
      if(mt){
        materialNumShort = mt.materialNumShort || "";
        description = mt.description || "";
      }
    }
    return {materialNumShort,description}
  }
const modalBody = (
  <div style={modalStyle} className={classes.paper} >

      <h2 id="simple-modal-title" style={{color: "crimson"}}>Material Replacement</h2>
      <div id="simple-modal-description" >
          <form noValidate autoComplete="off" style={{ paddingLeft: "5px"}}>
          <Grid container spacing={2} className={classes.modalGrid}>
          <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
          <InputLabel >Delivery Plant</InputLabel>
          <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant}
                inputProps={{name: 'Delivery Plant',}}
                className={classes.modalInput}
                onChange={(e) => { 
                  getMaterialNum(e.target.value);setEditedRowDeliveringPlant((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                <MenuItem key='*' value='*'>{salesOrg + " - All"}</MenuItem>
                {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                  
                    <MenuItem key={so[1].code} value={so[1].code}>
                      {so[1].code + " - " + so[1].text}
                    </MenuItem>
                    ))):(<></>)}
            </Select>
            </Grid>
              <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >Obsolete Material</InputLabel>
              <TextField placeholder='Obsolete Material' type='text'
                className={classes.modalInput}
                value={editedRowObsoletematerial}
                onChange={(e) => { 
                  seteditedRowObsoletematerial((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                }}></TextField>
              </Grid>
              <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >Replacement Material</InputLabel>
              
                <Select label="Material" required placeholder='Material' value={editedRowReplacementmaterial}
                inputProps={{name: 'Material',}}
                className={classes.modalInput}
                onChange={(e) => { 
                  seteditedRowReplacementmaterial((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                <MenuItem key='*' value='*'>{"All"}</MenuItem>
                {(materialList)?(Object.entries(materialList).map((so: any, i: number) => (
                  
                    <MenuItem key={so[1].material_num} value={so[1].material_num}>
                      {so[1].material_num_short} - {so[1].description}
                    </MenuItem>
                    ))):(<></>)}
            </Select>
              </Grid>
              <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >Valid From</InputLabel>
              <TextField placeholder='Valid From' type='date'
               className={classes.modalInput}
               value={editedRowValidfrom}
               onChange={(e) => {
                // console.log((new Date(e.target.value)).toString())
                // console.log(moment(e.target.value).format('YYYY-MM-DD'))
                 seteditedRowValidfrom(moment(e.target.value).format('YYYY-MM-DD'))
              }}
               ></TextField>
              </Grid>
              <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <InputLabel >Valid To</InputLabel>
              <TextField placeholder='Valid To' type='date'
                className={classes.modalInput}
                value={editedRowValidto}
                onChange={(e) => {
                 // console.log((new Date(e.target.value)).toString())
                  //console.log(moment(e.target.value).format('YYYY-MM-DD'))
                  seteditedRowValidto(moment(e.target.value).format('YYYY-MM-DD'))
               }}
                ></TextField>
              </Grid>
            </Grid>
            <br/>
            <div style={{ paddingRight: "5px", textAlign:"right"}}>
              <React.Fragment>
                  <Tooltip title={"Save"}>
                      <IconButton onClick={handleModalSave}>
                          <SaveIcon />
                      </IconButton>

                  </Tooltip>
                  <Tooltip title={"Cancel"}>
                      <IconButton onClick={handleModalClose}>
                          <Clear />
                      </IconButton>
                  </Tooltip>
              </React.Fragment>
            </div>

          </form>
      </div>

  </div>
);


  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES", "PLANTS"])
      .then((v) => {
        setCodes(v);
      })
       .then((_) =>{
        GetMaterialReplacement(salesOrg).then((v) => {
          setDoneLoading(true);
      
          if(v && v.mdMaterialReplacement) SetMaterialReplacement(v.mdMaterialReplacement);
        })
        .then((_) =>{
          getSalesOffices(salesOrg).then((v) => {
            if(v) setDeliveringPlants(v);
        });
      });

      });
  }, [materialReplacement,doneLoading,salesOrg]);

  useEffect(() => {
    GetAllMaterialText().then((v) => {
      setDoneLoading(true);
      if(v && v.materialTxt) setMaterialTexts(v.materialTxt);
    })
  }, []);
  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
          <TableAbstraction
            settingsKey="ADM_MRPL"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Replacement`}>
                    <IconButton  onClick={() => {
                      handleModalClose();
                      setOpenEditWindow(true);
                    }}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                );
              },
            }}
            title="Material Replacement"
            columns={[
              {
                label: "Sales Office",
                name: "salesOffice",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                    value === '*' ? salesOrg :`${value} - ${determineConfig(codes, "SALESOFFICES", value)}` ,
                },
              },
              {
                label: "Delivery Plant",
                name: "plant",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                    value === '*' ? salesOrg :`${value} - ${determineConfig(codes, "PLANTS", value)}` ,
                },
              },
              {
                label: "Obsolete Material",
                name: "obsoleteMaterialNum",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                  `${getMaterialText(value)?.materialNumShort} - ${getMaterialText(value)?.description}` ,
                },
              },
              {
                label: "Replacement Material",
                name: "replacementMaterialNum",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                  `${getMaterialText(value)?.materialNumShort} - ${getMaterialText(value)?.description}` ,
                },
              },
              {
                label: "Valid From",
                name: "validFromDt",
                options: {
                  filter: false,
                },
              },
              {
                label: "Valid To",
                name: "validToDt",
                options: {
                  filter: false,
                },
              },
              {
                label: " ",
                name: "active",
                options: {
                  filter: false,
                  setCellProps: () => ({ align: 'right' }),
                  renderCell: (params) => {
                    if(!!useCompact)
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <EditIcon 
                                fontSize="small"  
                                onClick={() => {handleEdit(params.row)}}/>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <DeleteIcon
                                fontSize="small" 
                                onClick={() => {setCurrent(params.row); setConfirmDelete(true);}} 
                              />
                            </Tooltip>
                          </React.Fragment>
                        );
                      else
                        return (
                            <React.Fragment>
                              <Tooltip title={"Edit"}>
                                <IconButton onClick={() => {handleEdit(params.row)}}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={"Delete"}>
                                <IconButton onClick={() => {setCurrent(params.row); setConfirmDelete(true);}}>
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </React.Fragment>
                          );
                  },
                },
              },
            ]}
            data={materialReplacement}
          />
        ) : ( enabled ? (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
          )
        )}
      
        <Modal
                  open={openEditWindow}
                  onClose={handleModalClose}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
              >
                  {modalBody}
  
              </Modal>
              <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{setEditedRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
}
